import internalControlsSlice from './internalControlsSlice';

export { default as internalControlsOp } from './operations';

export default internalControlsSlice;
